/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const StocktakeCountService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/StocktakeCount",
      top: "1",
      filter: `StocktakeCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveStocktakeCount(payload) {
    const url = `api/Save_StocktakeCount`;
    return await ApiService.post(url, payload);
  },
  async getStockTakeListItemById(code) {
    const requestScreenData = {
      url: "api/StocktakeList",
      top: "1",
      filter: `Code eq ` + parseInt(code),
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductDefaultData(StocktakeCode, ProductCode, BranchCode) {
    const requestScreenData = {
      url: "api/StocktakeCountProduct",
      top: "1",
      filter: `StocktakeCode eq ${parseInt(StocktakeCode)} and ProductCode eq '${ProductCode}' and BranchCode eq '${BranchCode}'`,
      select: ["ProductCode", "ProductDescription", "BranchCode", "BatchNo", "BinLocationCode", "Count", "CountToDate", "IsBatchProduct", "RecordId", "ReferenceNo", "StocktakeCode", "SupplierCode", "UnitOfMeasureCode"]
    };
    return await ApiService.oDataGet(requestScreenData);

  },

  async getStocktakeReviewList(params) {
    const requestScreenData = {
      url: "api/StocktakeReviewList",
      expand: 'StockTransferUnitOfMeasureList($select=UnitOfMeasure,BranchCode,ConversionFactor,DefaultUnitOfMeasure,DefaultUnitOfMeasureConversion)',
    };

    if (params) {
      if (params.filter) requestScreenData.filter = params.filter;
    }
    return await ApiService.oDataGet(requestScreenData);
  },

  async getStockTakeBatch(params) {
    const requestScreenData = {
      url: "api/StockBatch",
    };

    if (params) {
      if (params.filter) requestScreenData.filter = params.filter;
    }
    return await ApiService.oDataGet(requestScreenData);
  },

  async SaveStocktakeBatchProductCount(payload) {
    var url = `api/Save_StocktakeBatchProductCount`;
    return await ApiService.post(url, payload);
  }
};

export { StocktakeCountService };
